import { ref, onMounted, onBeforeUnmount } from "vue";

export function useViewport(breakpoint = 900) {
  const isMobileView = ref(false);

  const updateMobileView = () => {
    if (typeof window === "undefined") return;
    isMobileView.value = window.innerWidth <= breakpoint;
  };

  onMounted(() => {
    updateMobileView();
    window.addEventListener("resize", updateMobileView);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", updateMobileView);
  });

  return { isMobileView };
}